export default "__VITE_ASSET__04c487bb__"